module.exports = __webpack_public_path__ + "img/logoappcral.db784860.png";